import { render, staticRenderFns } from "./ListNotesMatter.vue?vue&type=template&id=1e7c4870"
import script from "./ListNotesMatter.vue?vue&type=script&lang=js"
export * from "./ListNotesMatter.vue?vue&type=script&lang=js"
import style0 from "./ListNotesMatter.vue?vue&type=style&index=0&id=1e7c4870&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports